module.exports = __webpack_public_path__ + "static/media/userIcon.4ed0959a.svg";